// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"df4c97d2","453":"5b186c07","473":"c311dbdc","489":"3e6c5e6a"}[chunkId] + ".chunk.js";
};